import React from 'react';

import Heading from '@atlaskit/heading';
import { Flex, Text, xcss } from '@atlaskit/primitives';

import type { WizardInfoItemProps } from './types';

export const WizardInfoItem = ({ iconBox, title, description }: WizardInfoItemProps) => (
	<Flex columnGap="space.100" alignItems="start" xcss={containerStyles}>
		{iconBox}
		<Flex rowGap="space.025" direction="column" xcss={contentWrapperStyles}>
			{title && (
				<Heading as="h2" size="xsmall">
					{title}
				</Heading>
			)}
			<Text>{description}</Text>
		</Flex>
	</Flex>
);

const containerStyles = xcss({
	paddingTop: 'space.050',
	paddingBottom: 'space.050',
});

const contentWrapperStyles = xcss({
	alignSelf: 'center',
});
